import { RevisionRow } from 'components/tables/data/revision/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the revision template.
 */
export default function RevisionTemplateColumn({ data: { revisionTemplate } }: { data: RevisionRow }) {
  return <P2Regular lineClamp={3}>{revisionTemplate?.name ?? ''}</P2Regular>;
}
